export default __webpack_public_path__ + "static/media/marker.e09a737b.svg";